/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import Cookies from 'js-cookie'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { Country, HeaderState, PosibleLocale } from 'src/core/models'
import { getCtCookie } from 'src/core/helpers'
import styles from './AuthLayout.module.scss'
import { useTranslation } from 'next-i18next'
import { ACCOUNT_PAGES, gtm_view } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { deleteAllCookies, removeToken } from 'src/core/helpers/auth'
import { TheFooter, ScrollTop, AuthDownLabels } from 'src/components'
import {
  setVerifyTokenRedirectLogin,
  verifyTokenSelector,
  setCountryListData,
  checkCookies,
  verifyToken,
  trackEvent,
  getHeaderData
} from 'src/features'

import { GlobalHeader } from '@climatetrade/ui'

interface AuthLayoutProps {
  headerData: HeaderState
  countries: Country[]
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = (props) => {
  const { children, headerData, countries } = props
  const { i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()
  const route = router.route
  const isNotVerifyRoute = !router?.asPath?.includes('verify-email')
  const token = Cookies.get(process.env.NEXT_PUBLIC_TOKEN_NAME)
  const { redirectLogin: tokenIsInvalid } = useAppSelector(verifyTokenSelector)

  const [currentHeaderData, setCurrenctHeaderData] = useState<HeaderState>(headerData)

  const languageCookie = getCtCookie('ct-language')

  useEffect(() => {
    const updateHeaderData = async () => {
      const newData = await getHeaderData(languageCookie as PosibleLocale)
      setCurrenctHeaderData(newData)
    }
    updateHeaderData()
  }, [languageCookie])


  useEffect(() => {
    dispatch(setCountryListData(countries))
  }, [dispatch])

  useEffect(() => {
    // Track Event To CT Micro-Server
    dispatch(checkCookies())
    dispatch(trackEvent(route, 'PAGE_VIEW'))

    // Track Page View With GTM
    gtm_view({ 'page_name': ACCOUNT_PAGES[route] })

    /* TOKEN VERIFY */
    if (token) { dispatch(verifyToken(token)) }
  }, [route])

  useEffect(() => {
    if (tokenIsInvalid) {
      removeToken()
      deleteAllCookies()
      dispatch(setVerifyTokenRedirectLogin(false))
    }
  }, [tokenIsInvalid])

  const handleLanguageChange = (languageValue: string) => {
    if(i18n.changeLanguage) { i18n.changeLanguage(languageValue) }
    router.push(router.asPath, undefined, { locale: languageValue })
  }

  return <>
    <GlobalHeader
      data={currentHeaderData}
      onLanguageChange={handleLanguageChange}
    />

    <ScrollTop />
    <main className={styles.content}>
      {children}
      {isNotVerifyRoute && <AuthDownLabels />}
    </main>

    <TheFooter />
  </>
}

export default AuthLayout
